/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DevTerminalIcon16Light } from './DevTerminalIcon16Light';
import { DevTerminalIcon16Regular } from './DevTerminalIcon16Regular';
import { DevTerminalIcon16Solid } from './DevTerminalIcon16Solid';
import { DevTerminalIcon20Light } from './DevTerminalIcon20Light';
import { DevTerminalIcon20Regular } from './DevTerminalIcon20Regular';
import { DevTerminalIcon20Solid } from './DevTerminalIcon20Solid';
import { DevTerminalIcon24Regular } from './DevTerminalIcon24Regular';
import { DevTerminalIcon24Solid } from './DevTerminalIcon24Solid';
import { DevTerminalIcon32Regular } from './DevTerminalIcon32Regular';
import { DevTerminalIcon64Regular } from './DevTerminalIcon64Regular';
var sizes = {
    16: {
        light: DevTerminalIcon16Light,
        regular: DevTerminalIcon16Regular,
        solid: DevTerminalIcon16Solid,
    },
    20: {
        light: DevTerminalIcon20Light,
        regular: DevTerminalIcon20Regular,
        solid: DevTerminalIcon20Solid,
    },
    24: {
        regular: DevTerminalIcon24Regular,
        solid: DevTerminalIcon24Solid,
    },
    32: {
        regular: DevTerminalIcon32Regular,
    },
    64: {
        regular: DevTerminalIcon64Regular,
    },
};
export var DevTerminalIcon = forwardRef('DevTerminalIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
